import React, { useContext } from "react"
import { LanguageContext } from "../../context"

 const Block = (props) => {

   const {
     logo,
     address,
     phone,
     schedule,
     menu1,
     menu2,
     children,
     newsletter,
     pos,
     className
    } = props


   const { t } = useContext(LanguageContext)
   return (
          <>
           {(logo  || address || phone || schedule) && pos===1 &&
            <div className={className}>
             {logo &&
               <img
               className="footer-logo white m-b-10"
               src={logo}
              />
             }

             {address &&
               <div className="footer-address m-b-10">
                  {address}
               </div>
             }

             {phone &&
               <div className="footer-phone m-b-10">
                  {phone}
               </div>
             }

             {schedule &&
               <div className="footer-schedule">
                {schedule}
               </div>
             }

         </div>
       }

         {children && pos==2 &&
           <div key={2} className={className}>
               {children}
           </div>
         }

         { children && pos==3&&
           <div key={3} className={className}>
               {children}
           </div>
         }


         {newsletter &&
           <div className="col-md-2 Normal-Medium-L---white">
               {newsletter}
           </div>
         }
      </>
   )

 }


export default Block
